import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import everywhereLogo from '../../../assets/images/logo-auth.svg';
import ButtonAuth from '../../../components/ButtonAuth';
import Dialog from '../../../components/Dialog';
import Input from '../../../components/Input';
import { isMobile } from 'react-device-detect';
import { useTrackingContext } from '../../../context/trackingContext';
import { useUserContext } from '../../../context/userContext';
import config from '../../../config';
import useClient from '../../../hooks/useClient';
import { calculateAge } from '../../../utils/calculateAge';

const Entitlements = () => {
  const { trackPageView, trackFormStart, trackFormSubmit, trackClick } = useTrackingContext();

  const { userData } = useUserContext();
  const client = useClient();

  const [hovered, setHovered] = useState(false);
  const handleXsollaClick = () => {
    const frame = document.getElementById('xsolla-installer-renamer') || null;

    if (frame && frame.contentWindow) {
      frame.contentWindow.postMessage(
        {
          type: 'download',
          href: process.env.REACT_APP_LAUNCHER_URL ?? '',
          name: 'BARB_Launcher_Installer.exe'
        },
        'https://installer.launcher.xsolla.com'
      );
    }
  };

  useEffect(() => {
    const frame = document.createElement('IFRAME');
    frame.id = 'xsolla-installer-renamer';
    frame.src = `https://installer.launcher.xsolla.com/launcher-installer-renamer-prod/v1/renamer.html?cache=${Date.now()}`;
    frame.style = 'display: none';
    document.body.append(frame);

    trackPageView({
      pageName: 'Entitlements'
    });
  }, []);

  const {
    control,
    handleSubmit,
    formState: { isValid, isSubmitting, isDirty }
  } = useForm({ mode: 'onTouched' });

  useEffect(() => {
    isDirty &&
      trackFormStart({
        formName: 'Entitlement code input start'
      });
  }, [isDirty]);

  const [addingCode, setAddingCode] = useState(false);
  const [age, setAge] = useState(false);

  const onSubmit = async (data) => {
    console.log(data);
    await new Promise((resolve) => setTimeout(resolve, 2000));

    trackFormSubmit({
      formName: 'Entitlement code submit'
    });

    setAddingCode(false);
  };

  const downloadEverywhere = async () => {
    try {
      const { data } = await client.get(`${config.everywhereApi}/users/self/profile/launcher`);

      const a = document.createElement('a');
      a.href = data.data.launcher;
      a.download = data.data.launcher.split('/').pop();
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch {
      console.error('Unable to fetch launcher');
    }
  };

  useEffect(() => {
    const age = calculateAge(userData?.dob);
    setAge(age);
  }, [userData]);

  return (
    <div id="Entitlements">
      <div className="relative">
        {/* <ButtonAuth
          onClick={() => {
            trackClick({ btnName: 'Adding code for entitlement' });
            setAddingCode(true);
          }}
          className="absolute z-10 top-3 right-0 uppercase w-full sm:w-[250px] text-white bg-red"
          label="Add Code"
        /> */}

        <div className="mt-12">
          <p>Download the BARB Launcher here.</p>
        </div>

        <div className="flex flex-row w-full pt-24 flex-wrap gap-y-3 uppercase">
          <img src={everywhereLogo} alt="BARB-logo" />
          <p className="pl-6 sm:pl-10 font-Korolev-Bold text-xl my-auto">BARB LAUNCHER</p>
          <hr className="my-auto grow hidden sm:block align-middle mx-6 border-dotted border-l-0 border-b-0 border-r-0 " />
          <div
            className="ml-auto min-w-[120px]"
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}>
            <ButtonAuth
              isDisabled={!userData?.entitlements?.everywhere || isMobile}
              onClick={() => {
                trackClick({ btnName: 'Download BARB clicked' });
                handleXsollaClick();
              }}
              className="sm:ml-0 uppercase w-full sm:w-[250px] text bg-black"
              label="Download"
            />
          </div>
        </div>
        <p
          className={`pt-2 text-right ${
            hovered && !userData?.entitlements?.everywhere ? 'visible' : 'invisible'
          }`}>
          This feature is currently not available
        </p>
        <p className={`pt-2 text-right ${isMobile ? 'visible' : 'invisible'}`}>
          Download only available on PC
        </p>
      </div>
      <Dialog
        isOpen={addingCode}
        onClose={() => {
          trackClick({ btnName: 'cancelled code for entitlement' });
          setAddingCode(false);
        }}
        email="rory@buildarocketboy.com"
        body={
          <div>
            <h1 className="font-Korolev-Bold text-5xl xl:text-5xl uppercase mb-2">Add Code</h1>

            <p className="text-black font-Korolev-Medium text-base mb-10">
              Enter the code exactly as it was provided. If your code has dashes please enter those
              as well.
            </p>

            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="mb-8">
                <Controller
                  control={control}
                  name="code"
                  defaultValue={''}
                  rules={{
                    required: true
                  }}
                  render={({ field: { value, onChange, onBlur } }) => (
                    <Input
                      type="code"
                      placeholder="Enter Code"
                      value={value}
                      onChange={onChange}
                      onBlur={onBlur}
                      className="w-full tracking-widest"
                    />
                  )}
                />
              </div>

              <hr className="w-full border-dotted border-l-0 border-b-0 border-r-0 mb-10 border-gray-light" />

              <ButtonAuth
                isSubmitting={isSubmitting}
                isDisabled={!isValid}
                label={'Add Code'}
                className="mb-5"
              />
            </form>
          </div>
        }
      />
    </div>
  );
};

export default Entitlements;
